module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAHlBMVEUAAAD///////////////////////////////////8kfJuVAAAACXRSTlMAARJvpNf1+fqjEOPsAAAASElEQVQ4y2MQMu2ciQpmBCsywIFK5Ux0MN0JIW0+ExMUI6QjsUhPRUhnYpGeRrRuAnYTcDkBf4+CYQZG0/loOh9N56PpnAYAAPRAPZ58zpgAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-menu.png
// module id = 641
// module chunks = 17